import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Result } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import Logo from "../components/general/Logo";
import { device } from "../lib/breakpoints";

const VendorBidSuccess = () => {
  const location = useLocation();
  const { ticketTitle, bidAmount, ticketId, workOrderId } =
    location.state || {};
  const workOrderDisplayId = workOrderId || ticketId || "-";

  return (
    <PageContainer>
      <Container>
        <LogoSection>
          <Logo size="large" displayMode="both" />
        </LogoSection>

        <Result
          status="success"
          icon={
            <CheckCircleOutlined style={{ color: "var(--color-success)" }} />
          }
          title={<SuccessTitle>Bid Accepted.</SuccessTitle>}
          subTitle={
            <SuccessSubtitle>
              Work Order #{workOrderDisplayId} is SCHEDULED.
              {ticketTitle ? ` (${ticketTitle})` : ""}
              {bidAmount != null
                ? ` - $${Number(bidAmount).toLocaleString()}`
                : ""}
            </SuccessSubtitle>
          }
          extra={
            <ThankYouNote>
              Thank you for working with Clumse property owners. We
              appreciate professional contractors who help maintain quality
              properties.
            </ThankYouNote>
          }
        />
      </Container>
    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.mobile} {
    padding: 1rem 0.5rem;
  }
`;

const Container = styled.div`
  max-width: 700px;
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 3rem 2rem;

  @media ${device.mobile} {
    padding: 2rem 1rem;
  }
`;

const LogoSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

const SuccessTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--color-text);
  font-family: var(--font-primary);

  @media ${device.mobile} {
    font-size: 1.4rem;
  }
`;

const SuccessSubtitle = styled.div`
  font-size: 1.1rem;
  color: var(--color-text-muted);
  line-height: 1.6;
  margin-top: 1rem;

  @media ${device.mobile} {
    font-size: 1rem;
  }
`;

const ThankYouNote = styled.p`
  font-size: 1rem;
  color: var(--color-text-muted);
  line-height: 1.6;
  margin: 0;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
  font-style: italic;
`;

export default VendorBidSuccess;
